import React, { useState } from "react";
import Header from "../components/Header";
import Header2 from "../components/Header2";
import Footer from "../components/Footer";

import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import "../assets/css/menu.css";
import "../assets/css/vendors.css";
import "../assets/css/icon_fonts/css/all_icons_min.css";
import "../assets/css/custom.css";

const doctorsData = [
  {
    name: "Dr. Priya Sharma",
    qualification: "MBBS, MD - Vascular Medicine",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "15 Years Experience",
    location: "2nd Floor, MS Tower, Banjara Hills, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "DVT Treatment Specialist"
  },
  {
    name: "Dr. Anjali Mehta",
    qualification: "MBBS, DNB - Vascular Surgery",
    fee: " FREE Consultation",
    rating: "4.9/5",
    experience: "12 Years Experience",
    location: "Apurupa Urban, No 201, 2nd Floor, Image Gardens Rd, near Chirec School, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Thrombectomy Expert"
  },
  {
    name: "Dr. Rohan Verma",
    qualification: "MBBS, MS - Vascular Surgery",
    fee: " FREE Consultation",
    rating: "4.7/5",
    experience: "14 Years Experience",
    location: "Annapurna Kalyana Mandapam Srinagar Nagar, Dilsukhnagar, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Interventional Radiology"
  },
  {
    name: "Dr. Sneha Reddy",
    qualification: "MBBS, MD - Hematology",
    fee: " FREE Consultation",
    rating: "4.6/5",
    experience: "11 Years Experience",
    location: "123 Green Avenue, Banjara Hills, Hyderabad",
    phone: "080-6541-7710",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Blood Clot Disorders"
  },
  {
    name: "Dr. Kavita Patel",
    qualification: "MBBS, MS - General Surgery",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "16 Years Experience",
    location: "45 Tower Road, Jubilee Hills, Hyderabad",
    phone: "080-6541-7720",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Advanced DVT Care"
  },
  {
    name: "Dr. Arjun Kumar",
    qualification: "MBBS, MD - Cardiology",
    fee: "FREE Consultation",
    rating: "4.7/5",
    experience: "13 Years Experience",
    location: "21 MG Road, Hyderabad",
    phone: "080-6541-7730",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Pulmonary Embolism Specialist"
  },
];

const DoctorsSection = () => {
  const [showAll, setShowAll] = useState(false);
  const displayedDoctors = showAll ? doctorsData : doctorsData.slice(0, 6);

  return (
    <div style={{ padding: "80px 20px", backgroundColor: "#f8f9fa" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto", fontFamily: "'Poppins', sans-serif" }}>
        <div style={{ textAlign: "center", marginBottom: "50px" }}>
          <h2 style={{ fontSize: "42px", fontWeight: "800", color: "#0b1c39", marginBottom: "15px" }}>
            Our <span style={{ color: "#ffcb24" }}>DVT Treatment Specialists</span>
          </h2>
          <p style={{ fontSize: "18px", color: "#555", maxWidth: "600px", margin: "0 auto", lineHeight: "1.8" }}>
            Expert care for Deep Vein Thrombosis with advanced clot removal techniques and comprehensive prevention strategies.
          </p>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "25px", justifyContent: "space-between" }}>
          {displayedDoctors.map((doc, index) => (
            <div
              key={index}
              style={{
                flex: "0 0 calc(33.33% - 17px)",
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "25px",
                boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "20px",
                border: "1px solid rgba(9,187,175,0.1)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 12px 35px rgba(0,0,0,0.12)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 8px 30px rgba(0,0,0,0.08)";
              }}
            >
              <div style={{ position: "relative", flexShrink: 0 }}>
                <img
                  src={doc.image}
                  alt={doc.name}
                  style={{
                    width: "95px",
                    height: "95px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "3px solid #09bbaf",
                    backgroundColor: "#f8f8f8",
                  }}
                />
                {doc.online && (
                  <span
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      right: "8px",
                      width: "14px",
                      height: "14px",
                      backgroundColor: "#09bbaf",
                      borderRadius: "50%",
                      border: "2px solid #fff",
                    }}
                    title="Online"
                  ></span>
                )}
              </div>

              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: "18px", fontWeight: "700", color: "#0b1c39", marginBottom: "6px" }}>
                  {doc.name}
                </h3>
                <p style={{ color: "#09bbaf", fontSize: "14px", marginBottom: "6px", fontWeight: "600" }}>
                  {doc.specialization}
                </p>
                <p style={{ color: "#555", fontSize: "14px", marginBottom: "6px" }}>
                  {doc.qualification}
                </p>
                <p style={{ fontWeight: "600", color: "#09bbaf", marginBottom: "6px", fontSize: "15px" }}>
                  {doc.fee}
                </p>
                <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
                  <span style={{ fontSize: "14px", color: "#555" }}>⭐ {doc.rating}</span>
                  <span style={{ fontSize: "14px", color: "#555" }}>{doc.experience}</span>
                </div>
                <p style={{ fontSize: "13px", color: "#555", display: "flex", alignItems: "flex-start", gap: "6px", marginBottom: "6px", lineHeight: "1.4" }}>
                  📍 {doc.location}
                </p>
                <p style={{ fontSize: "13px", color: "#555", marginBottom: "15px" }}>
                  📞 {doc.phone}
                </p>

                <button
                  style={{
                    padding: "12px 20px",
                    border: "none",
                    borderRadius: "30px",
                    backgroundColor: "#ffcb24",
                    color: "#0b1c39",
                    cursor: "pointer",
                    width: "100%",
                    fontWeight: "600",
                    fontSize: "14px",
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#ffd84f")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#ffcb24")}
                >
                  Book Free Consultation
                </button>
              </div>
            </div>
          ))}
        </div>

        {!showAll && doctorsData.length > 6 && (
          <div style={{ textAlign: "center", marginTop: "40px" }}>
            <button
              onClick={() => setShowAll(true)}
              style={{
                padding: "14px 40px",
                fontSize: "16px",
                borderRadius: "12px",
                border: "none",
                backgroundColor: "#09bbaf",
                color: "#fff",
                cursor: "pointer",
                fontWeight: "700",
                boxShadow: "0 8px 25px rgba(9,187,175,0.3)",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#0dcfc2")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#09bbaf")}
            >
              View More Doctors ▼
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const DVTTreatment = () => {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <>
      <Header />
      <Header2 />

      {/* Hero Section */}
      <section style={{
        background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
        padding: "160px 0 100px",
        marginTop: "56px",
        color: "white",
        textAlign: "center",
        position: "relative",
        overflow: "hidden"
      }}>
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <h1 style={{
            fontSize: "3.5rem",
            fontWeight: "800",
            marginBottom: "20px",
            color: "white"
          }}>
            Comprehensive DVT Treatment
          </h1>
          <p style={{
            fontSize: "1.3rem",
            marginBottom: "30px",
            opacity: "0.9",
            maxWidth: "700px",
            margin: "0 auto 30px",
            lineHeight: "1.6"
          }}>
            Advanced Deep Vein Thrombosis Care with 95% Success Rate. Emergency & Preventive Care for Blood Clot Disorders.
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap" }}>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Emergency DVT Care
            </button>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "2px solid #ffcb24",
              backgroundColor: "transparent",
              color: "#ffcb24",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.color = "#0b1c39";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "#ffcb24";
            }}>
              Prevention Assessment
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={{ backgroundColor: "#fff", padding: "60px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>1 in 1000</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Annual Incidence</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>95%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Treatment Success</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>24/7</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Emergency Care</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>60%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Risk Reduction</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Doctors Section */}
      <DoctorsSection />

      {/* Navigation Tabs */}
      <section style={{ backgroundColor: "#fff", padding: "40px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap" }}>
            {[
              { id: "overview", label: "Overview", icon: "📋" },
              { id: "symptoms", label: "Symptoms", icon: "🔍" },
              { id: "risks", label: "Risk Factors", icon: "🎯" },
              { id: "diagnosis", label: "Diagnosis", icon: "🔬" },
              { id: "treatment", label: "Treatment", icon: "⚕️" },
              { id: "prevention", label: "Prevention", icon: "🔄" },
              { id: "complications", label: "Complications", icon: "🛡️" }
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  padding: "12px 24px",
                  borderRadius: "25px",
                  border: "none",
                  backgroundColor: activeTab === tab.id ? "#09bbaf" : "#f8f9fa",
                  color: activeTab === tab.id ? "white" : "#555",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease"
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="container" style={{ padding: "80px 15px" }}>

        {/* Comprehensive Overview */}
        <section style={{ marginBottom: "80px" }}>
          <div style={{ textAlign: "center", marginBottom: "60px" }}>
            <h2 style={{ fontSize: "36px", fontWeight: "800", color: "#0b1c39", marginBottom: "20px" }}>
              Complete Guide to <span style={{ color: "#09bbaf" }}>DVT Treatment</span>
            </h2>
          </div>

          {/* What is DVT */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "50px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "1px solid rgba(9,187,175,0.1)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px" }}>
                Understanding Deep Vein Thrombosis (DVT)
              </h3>
              
              <p style={{ color: "#555", lineHeight: "1.8", fontSize: "1.1rem", marginBottom: "25px" }}>
                Deep Vein Thrombosis (DVT) is a serious medical condition where a blood clot forms in one or more 
                of the deep veins in your body, typically in the legs. DVT can cause leg pain or swelling, but may 
                occur without any symptoms. The most serious complication of DVT is pulmonary embolism (PE), which 
                occurs when a blood clot breaks loose and travels to the lungs, blocking blood flow.
              </p>

              <div className="row">
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #09bbaf",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Emergency Condition</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      DVT is a medical emergency that requires immediate treatment to prevent 
                      life-threatening complications like pulmonary embolism and long-term damage.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #ffcb24",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Progressive Condition</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Without proper treatment, DVT can lead to post-thrombotic syndrome, 
                      chronic pain, swelling, and permanent vein damage affecting quality of life.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Detailed Symptoms */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              DVT Symptoms & Warning Signs
            </h3>

            <div className="row">
              {[
                {
                  title: "Leg Swelling", 
                  description: "Sudden swelling in one leg, typically more pronounced than the other",
                  details: "Most common symptom, usually affects calf or entire leg"
                },
                {
                  title: "Leg Pain", 
                  description: "Persistent pain that often starts in the calf and feels like cramping",
                  details: "Pain may worsen when bending foot upward toward knee"
                },
                {
                  title: "Skin Warmth", 
                  description: "Affected area feels warm to touch compared to surrounding skin",
                  details: "Caused by inflammation around the clot location"
                },
                {
                  title: "Skin Discoloration", 
                  description: "Red or bluish skin discoloration over the affected area",
                  details: "Indicates compromised blood flow and inflammation"
                },
                {
                  title: "Vein Visibility", 
                  description: "Surface veins become more prominent or visible",
                  details: "Due to increased pressure in the venous system"
                },
                {
                  title: "Pulmonary Embolism Signs", 
                  description: "Sudden shortness of breath, chest pain, coughing blood",
                  details: "MEDICAL EMERGENCY - requires immediate hospital care"
                }
              ].map((symptom, index) => (
                <div key={index} className="col-lg-4 col-md-6 mb-4">
                  <div style={{
                    backgroundColor: "#fff",
                    borderRadius: "15px",
                    padding: "25px",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                    border: "1px solid rgba(9,187,175,0.1)",
                    height: "100%",
                    transition: "transform 0.3s ease"
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                  onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                      {symptom.title}
                    </h5>
                    <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                      {symptom.description}
                    </p>
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "8px",
                      padding: "12px",
                      borderLeft: "3px solid #09bbaf"
                    }}>
                      <p style={{ color: "#666", fontSize: "0.9rem", lineHeight: "1.5", margin: 0 }}>
                        {symptom.details}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* DVT Types & Classification */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              DVT Classification & Severity
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    type: "Proximal DVT",
                    description: "Clots in popliteal, femoral, or iliac veins - higher risk of pulmonary embolism",
                    treatment: "Anticoagulants, Thrombolysis, Thrombectomy, IVC filter"
                  },
                  {
                    type: "Distal DVT",
                    description: "Clots in calf veins below the knee - lower risk of complications",
                    treatment: "Anticoagulants, Compression, Monitoring, Lifestyle changes"
                  },
                  {
                    type: "Iliofemoral DVT",
                    description: "Extensive clots in iliac and femoral veins - highest risk category",
                    treatment: "Catheter-directed thrombolysis, Mechanical thrombectomy, Stenting"
                  },
                  {
                    type: "Recurrent DVT",
                    description: "New clot formation after previous DVT episode",
                    treatment: "Long-term anticoagulation, Comprehensive risk assessment"
                  },
                  {
                    type: "Bilateral DVT",
                    description: "Clots in both legs simultaneously - indicates systemic clotting disorder",
                    treatment: "Aggressive anticoagulation, Underlying cause investigation"
                  },
                  {
                    type: "Upper Extremity DVT",
                    description: "Clots in arm veins - often related to catheters or trauma",
                    treatment: "Anticoagulation, Catheter removal, Compression therapy"
                  }
                ].map((type, index) => (
                  <div key={index} className="col-lg-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      border: "2px solid #09bbaf",
                      height: "100%"
                    }}>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                        {type.type}
                      </h5>
                      <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                        {type.description}
                      </p>
                      <div style={{
                        backgroundColor: "#09bbaf",
                        color: "white",
                        padding: "8px 15px",
                        borderRadius: "20px",
                        display: "inline-block",
                        fontSize: "0.9rem",
                        fontWeight: "600"
                      }}>
                        {type.treatment}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Risk Factors */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#0b1c39",
              borderRadius: "20px",
              padding: "50px",
              color: "white"
            }}>
              <h3 style={{ fontSize: "28px", fontWeight: "800", marginBottom: "30px", color: "#ffcb24" }}>
                DVT Risk Factors & Causes
              </h3>
              
              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Major Risk Factors</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Recent surgery (especially orthopedic)</li>
                      <li style={{ marginBottom: "10px" }}>Prolonged immobility (travel, hospitalization)</li>
                      <li style={{ marginBottom: "10px" }}>Cancer and cancer treatments</li>
                      <li style={{ marginBottom: "10px" }}>Previous DVT or family history</li>
                      <li>Inherited clotting disorders</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Additional Risk Factors</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Age over 60 years</li>
                      <li style={{ marginBottom: "10px" }}>Obesity and overweight</li>
                      <li style={{ marginBottom: "10px" }}>Smoking and tobacco use</li>
                      <li style={{ marginBottom: "10px" }}>Pregnancy and postpartum period</li>
                      <li>Hormone therapy or birth control pills</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Treatment Options */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Comprehensive DVT Treatment Approaches
            </h3>

            <div className="row">
              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #09bbaf",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Medical Management
                  </h4>
                  
                  <p style={{ color: "#555", lineHeight: "1.8", marginBottom: "25px" }}>
                    Anticoagulant therapy is the cornerstone of DVT treatment, preventing clot extension 
                    and new clot formation while the body's natural systems work to dissolve existing clots. 
                    Modern anticoagulants offer improved safety profiles and convenience.
                  </p>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Anticoagulant Options:</h6>
                    <div className="row">
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>Direct Oral Anticoagulants (DOACs)</li>
                          <li style={{ marginBottom: "8px" }}>Warfarin (Vitamin K antagonist)</li>
                          <li style={{ marginBottom: "8px" }}>Low Molecular Weight Heparin</li>
                        </ul>
                      </div>
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>Unfractionated Heparin (IV)</li>
                          <li style={{ marginBottom: "8px" }}>Fondaparinux</li>
                          <li style={{ marginBottom: "8px" }}>Aspirin (secondary prevention)</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Treatment Duration:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "8px" }}>3 months for provoked DVT</li>
                      <li style={{ marginBottom: "8px" }}>6-12 months for unprovoked DVT</li>
                      <li style={{ marginBottom: "8px" }}>Indefinite for recurrent DVT</li>
                      <li>Lifelong for certain high-risk conditions</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #ffcb24",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Interventional & Surgical Options
                  </h4>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Advanced Procedures:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Catheter-directed Thrombolysis</li>
                      <li style={{ marginBottom: "10px" }}>Mechanical Thrombectomy</li>
                      <li style={{ marginBottom: "10px" }}>Pharmacomechanical Catheter-directed Thrombolysis</li>
                      <li style={{ marginBottom: "10px" }}>Inferior Vena Cava (IVC) Filter Placement</li>
                      <li>Venous Stenting for May-Thurner Syndrome</li>
                    </ul>
                  </div>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Surgical Options:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Venous Thrombectomy</li>
                      <li style={{ marginBottom: "10px" }}>Surgical Bypass for chronic cases</li>
                      <li style={{ marginBottom: "10px" }}>Venous Valve Repair</li>
                      <li style={{ marginBottom: "10px" }}>IVC Filter Retrieval</li>
                      <li>Combined open and endovascular approaches</li>
                    </ul>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Procedure Selection:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Based on clot location and extent</li>
                      <li style={{ marginBottom: "10px" }}>Patient symptoms and risk factors</li>
                      <li>Availability of specialized expertise</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Treatment Comparison */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              DVT Treatment Options Comparison
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    period: "DOACs",
                    title: "Oral Anticoagulants",
                    activities: ["Once/twice daily", "No monitoring", "Rapid onset", "Lower bleed risk"]
                  },
                  {
                    period: "Warfarin",
                    title: "Traditional Option",
                    activities: ["Once daily", "Regular INR checks", "Diet restrictions", "Cost-effective"]
                  },
                  {
                    period: "Thrombolysis",
                    title: "Clot Dissolution",
                    activities: ["Hospital procedure", "Rapid clot removal", "Higher bleed risk", "Selected cases"]
                  },
                  {
                    period: "Thrombectomy",
                    title: "Mechanical Removal",
                    activities: ["Minimally invasive", "Immediate results", "Preserves valves", "Complex cases"]
                  }
                ].map((treatment, index) => (
                  <div key={index} className="col-lg-3 col-md-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      textAlign: "center",
                      border: "1px solid rgba(9,187,175,0.2)",
                      height: "100%"
                    }}>
                      <div style={{ 
                        backgroundColor: "#09bbaf", 
                        color: "white", 
                        width: "60px", 
                        height: "60px", 
                        borderRadius: "50%", 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "center", 
                        margin: "0 auto 15px",
                        fontWeight: "700",
                        fontSize: "0.9rem"
                      }}>
                        {treatment.period}
                      </div>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.1rem" }}>
                        {treatment.title}
                      </h5>
                      <ul style={{ color: "#555", fontSize: "0.85rem", paddingLeft: "15px", textAlign: "left" }}>
                        {treatment.activities.map((activity, idx) => (
                          <li key={idx} style={{ marginBottom: "8px" }}>{activity}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Prevention & Recovery */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "2px solid rgba(255,203,36,0.3)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px", textAlign: "center" }}>
                Prevention & Long-term Management
              </h3>

              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Prevention Strategies</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Regular movement and exercise</li>
                      <li style={{ marginBottom: "10px" }}>Compression stockings during travel</li>
                      <li style={{ marginBottom: "10px" }}>Hydration and weight management</li>
                      <li>Prophylactic anticoagulation for high-risk situations</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Long-term Management</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Regular follow-up and monitoring</li>
                      <li style={{ marginBottom: "10px" }}>Compression therapy for post-thrombotic syndrome</li>
                      <li style={{ marginBottom: "10px" }}>Lifestyle modifications</li>
                      <li>Education about bleeding risk and emergency signs</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Frequently Asked Questions
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              {[
                {
                  question: "How long does DVT treatment typically last?",
                  answer: "The duration of DVT treatment depends on several factors including whether the clot was provoked (caused by a temporary risk factor) or unprovoked, the location and size of the clot, and individual patient factors. For provoked DVT (after surgery, trauma, or temporary immobility), treatment typically lasts 3 months. For unprovoked DVT, initial treatment is usually 3-6 months, after which we reassess the need for continued therapy. Patients with recurrent DVT or persistent high-risk factors may require lifelong anticoagulation. We individualize treatment duration based on bleeding risk, clot characteristics, and underlying conditions, with regular reassessment to ensure optimal balance between clot prevention and bleeding risk."
                },
                {
                  question: "What are the warning signs that my DVT might be getting worse?",
                  answer: "Several warning signs indicate your DVT may be worsening or complications developing: Increasing leg pain, swelling, or redness; Development of chest pain, shortness of breath, or coughing up blood (signs of pulmonary embolism - MEDICAL EMERGENCY); Unexplained bleeding while on blood thinners; Severe headache, vision changes, or neurological symptoms (possible bleeding in brain); Signs of infection like fever, chills, or pus drainage; Skin breakdown, ulcers, or color changes in the affected limb. If you experience any of these symptoms, especially chest pain or breathing difficulties, seek immediate medical attention. Regular follow-up with your vascular specialist is crucial for monitoring treatment effectiveness and catching complications early."
                },
                {
                  question: "Can I travel after being diagnosed with DVT?",
                  answer: "Travel after DVT diagnosis requires careful planning and medical guidance. Generally, we recommend waiting until your condition is stable and you're established on effective anticoagulation therapy, typically 2-4 weeks after diagnosis. For air travel, compression stockings are essential, and you should take additional precautions: Walk and stretch every 1-2 hours during flights; Stay well-hydrated and avoid alcohol; Consider prophylactic anticoagulation for long flights; Carry your medications in your carry-on luggage; Have emergency contact information readily available. We provide personalized travel recommendations based on your specific situation, including whether you need additional medication for travel and how to manage your anticoagulation across time zones."
                },
                {
                  question: "What is post-thrombotic syndrome and how can it be prevented?",
                  answer: "Post-thrombotic syndrome (PTS) is a common long-term complication of DVT characterized by chronic pain, swelling, skin changes, and sometimes ulcers in the affected limb. It occurs in 20-50% of DVT patients due to permanent vein damage and valve dysfunction. Prevention strategies include: Early and adequate anticoagulation therapy; Consistent use of medical-grade compression stockings; Leg elevation when resting; Regular exercise and walking; Maintaining healthy weight; In selected cases, early clot removal procedures like thrombolysis or thrombectomy. If PTS develops, treatment focuses on symptom management with compression therapy, specialized exercises, skin care, and sometimes venous procedures. Early intervention and consistent preventive measures significantly reduce PTS risk and severity."
                },
                {
                  question: "Are there any new advancements in DVT treatment?",
                  answer: "Yes, several exciting advancements have improved DVT treatment: Direct Oral Anticoagulants (DOACs) like rivaroxaban, apixaban, and dabigatran offer convenience without routine blood monitoring; Catheter-directed thrombolysis allows targeted clot dissolution with lower medication doses; Mechanical thrombectomy devices can physically remove clots through minimally invasive procedures; Improved IVC filters that are retrievable and have better safety profiles; Genetic testing to identify inherited thrombophilias for personalized treatment planning; Advanced ultrasound and imaging techniques for better diagnosis and monitoring; Research into novel anticoagulants with even better safety profiles. Our vascular center stays at the forefront of these advancements to provide our patients with the most effective and safest treatment options available."
                }
              ].map((faq, index) => (
                <div key={index} style={{ 
                  marginBottom: "25px",
                  paddingBottom: "25px",
                  borderBottom: index < 4 ? "1px solid #eee" : "none"
                }}>
                  <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "10px" }}>
                    {faq.question}
                  </h5>
                  <p style={{ color: "#555", lineHeight: "1.6", margin: 0 }}>
                    {faq.answer}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Final CTA */}
          <div style={{
            background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
            borderRadius: "20px",
            padding: "60px 40px",
            textAlign: "center",
            color: "white"
          }}>
            <h2 style={{ fontSize: "2.5rem", fontWeight: "800", marginBottom: "20px" }}>
              Concerned About DVT Symptoms?
            </h2>
            <p style={{ fontSize: "1.2rem", marginBottom: "30px", opacity: "0.9", maxWidth: "600px", margin: "0 auto 30px" }}>
              Our expert vascular team provides comprehensive DVT diagnosis, treatment, and prevention care with 24/7 emergency services.
            </p>
            <button style={{
              padding: "18px 45px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "800",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Emergency DVT Assessment
            </button>
            <p style={{ marginTop: "20px", fontSize: "1rem", opacity: "0.8" }}>
              Emergency Line: <strong>080-6541-7705</strong> | Vascular Clinic: <strong>080-6541-7706</strong>
            </p>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default DVTTreatment;